import type { BgColorCode, BorderColorCode } from '@smiledragon-corp/sds-system';
import type { RowProps } from '@smiledragon-corp/sds-system/components';
import { Box, Row } from '@smiledragon-corp/sds-system/components';
import type { ReactNode, SVGProps } from 'react';
import {
  BannerCharacterBlue,
  BannerCharacterGreen,
  BannerCharacterOrange,
  BannerCharacterRed,
  BannerCharacterYellow,
} from '../../assets/icon/Icons';

type ColorVariant = 'blue' | 'green' | 'orange' | 'red' | 'yellow';
export type InfoBannerProps = {
  children?: ReactNode;
  colorVariant?: ColorVariant;
  endIcon?: ReactNode;
  onClick?: () => void;
  slots?: {
    content?: RowProps;
    root?: RowProps;
  };
};

export const InfoBanner = (props: InfoBannerProps) => {
  const { colorVariant = 'blue', children, endIcon } = props;
  const { bgColor, borderColor, Character } = getColorVariantStyle(colorVariant);
  const { root, content } = props.slots ?? {};
  return (
    <Row
      bgColor={bgColor}
      border={`1 solid ${borderColor}`}
      br={8}
      position='relative'
      px={16}
      py={12}
      shadow='center.normal'
      {...(props.onClick && { onClick: props.onClick })}
      {...(root && root)}
    >
      <Box css={{ top: '-20px' }} left={12} position='absolute'>
        <Character />
      </Box>
      <Row
        alignItems='center'
        justifyContent='space-between'
        width='100%'
        {...(content && content)}
      >
        {children}
        {endIcon}
      </Row>
    </Row>
  );
};

const colorMap: Record<
  ColorVariant,
  {
    Character: (props: SVGProps<SVGSVGElement>) => JSX.Element;
    bgColor: BgColorCode;
    borderColor: BorderColorCode;
  }
> = {
  blue: { bgColor: 'bg.infoSubtle', borderColor: 'border.info', Character: BannerCharacterBlue },
  green: {
    bgColor: 'bg.successSubtle',
    borderColor: 'border.success',
    Character: BannerCharacterGreen,
  },
  orange: {
    bgColor: 'bg.dangerSubtle',
    borderColor: 'border.danger',
    Character: BannerCharacterOrange,
  },
  red: { bgColor: 'bg.errorSubtle', borderColor: 'border.error', Character: BannerCharacterRed },
  yellow: {
    bgColor: 'bg.pointSubtle',
    borderColor: 'border.point',
    Character: BannerCharacterYellow,
  },
};
const getColorVariantStyle = (colorVariant: ColorVariant) => {
  return colorMap[colorVariant];
};
